import { v4 } from 'uuid'
import { Env, getSessionStorage } from '@voghion/fe-util'
import { isEnvTest } from './env'

/**
 * 开发环境 mock clientInfo
 * @param {*} clientInfoRes
 */
export const mockClientInfo = (clientInfoRes, searchToken) => {
  if (searchToken || (process.env.NODE_ENV !== 'production' && !clientInfoRes.data.clientIp)) {
    const env = Env.getInstance()
    const session = getSessionStorage()
    let deviceCode = session.getItem('device_code')
    if (!deviceCode) {
      deviceCode = 'dev-' + v4()
      session.setItem('device_code', deviceCode)
    }
    let userToken = session.getItem('userToken') || ''
    if (!userToken) {
      userToken = isEnvTest() ? '45ad309443a9d885f9394359222c2d6e' : '6f3301bbfc23f9c072d4fb4da72bcaa9'
      session.setItem('userToken', userToken)
    }
    clientInfoRes.data = {
      appName: 'Voghion',
      appSystem: 'h5',
      appSystemVersion: env.appSystemVersion,
      appVersion: '2.0.0',
      channel: 1,
      gender: 3,
      country: 'DE',
      deviceCode: deviceCode,
      interfaceVersion: '99',
      language: 'en',
      systemLanguage: 'en',
      netType: 'wifi',
      phoneType: '',
      tradeName: 'h5',
      userToken: searchToken || userToken,
      currency: 'EUR'
    }
  }
}
